// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc0bfff8","732":"28c2f092","762":"d6d6eac8","977":"6d4ea961"}[chunkId] + ".chunk.js";
};